<script>
    export let width = 60;
    export let height = 45;
    export let color = "#fff";
</script>


<svg {width} {height} viewBox="0 0 512 512">
    <path
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="32"
        d="M344 280l88-88M232 216l64 64M80 320l104-104"
    />
    <circle
        stroke={color}
        cx="456"
        cy="168"
        r="24"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="32"
    />
    <circle
        stroke={color}
        cx="320"
        cy="304"
        r="24"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="32"
    />
    <circle
        stroke={color}
        cx="208"
        cy="192"
        r="24"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="32"
    />
    <circle
        stroke={color}
        cx="56"
        cy="344"
        r="24"
        fill="none"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="32"
    />
</svg>
